import styled from 'styled-components'
import { flowToIcon } from './flow-to-icon'

const Container = styled.div<{ $active: boolean }>`
  text-align: center;
  padding: 10px 10px 5px 10px;
  border-radius: 25px 25px 0 0;
  background: ${({ $active }) => ($active ? '#f2f2f2' : 'transparent')};

  &:hover {
    cursor: pointer;
  }
`

const Icon = styled.img`
  width: 40px;
  height: 40px;
`

const ProgBarContainer = styled.div<{ $active: boolean }>`
  border-radius: 4px;
  background: ${({ $active }) => ($active ? 'white' : '#f1f2f2')};
`

const ProgBar = styled.div<{ $percent: number; $mainColor?: string }>`
  width: ${({ $percent }) => $percent}%;
  height: 0.5rem;
  margin: 10px 0;
  border-radius: 4px;
  background: ${({ $mainColor }) => $mainColor || 'var(--mainHighlight)'} !important;
`

export interface ProgressMenuItemProps {
  iconName: string
  activeTab: boolean
  percent: number
  mainColor?: string
  onItemClicked: (iconName: string) => void
}

export const ProgressMenuItem = ({
  iconName,
  activeTab,
  percent,
  mainColor,
  onItemClicked,
}: ProgressMenuItemProps) => {
  const botIconsUrl = process.env.VUE_APP_ASSETS || ''
  const percentageLabel = `${Math.floor(percent)}%`

  return (
    <Container
      $active={activeTab}
      onClick={() => onItemClicked(iconName)}
      draggable
    >
      <Icon src={`${botIconsUrl}/${flowToIcon(iconName)}`} alt={iconName} />
      <ProgBarContainer $active={activeTab} title={percentageLabel}>
        <ProgBar $percent={percent} $mainColor={mainColor} />
      </ProgBarContainer>
    </Container>
  )
}
